import React from 'react';

interface IProps {
  pathProps?: React.SVGProps<SVGPathElement>;
}

const TrashShaxmatkaIcon = ({ pathProps }: IProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6667 3.99999V3.46666C10.6667 2.71992 10.6667 2.34656 10.5213 2.06134C10.3935 1.81046 10.1895 1.60648 9.93865 1.47865C9.65344 1.33333 9.28007 1.33333 8.53333 1.33333H7.46667C6.71993 1.33333 6.34656 1.33333 6.06135 1.47865C5.81046 1.60648 5.60649 1.81046 5.47866 2.06134C5.33333 2.34656 5.33333 2.71992 5.33333 3.46666V3.99999M6.66667 7.66666V11M9.33333 7.66666V11M2 3.99999H14M12.6667 3.99999V11.4667C12.6667 12.5868 12.6667 13.1468 12.4487 13.5746C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6667 10.5868 14.6667 9.46667 14.6667H6.53333C5.41323 14.6667 4.85318 14.6667 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5746C3.33333 13.1468 3.33333 12.5868 3.33333 11.4667V3.99999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...pathProps}
    />
  </svg>
);

export default TrashShaxmatkaIcon;
